import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useIoContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { integrationModel } from '~/models';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import FinancialCentsLogo from '../logos/financial-cents.svg';
const deprecatedTestIds = {
    FinancialCentsCardTID: {
        Root: ()=>'financial-cents-card',
        Connect: ()=>'financial-cents-connect',
        ManageConnection: ()=>'financial-cents-manage-connection'
    }
};
export const GetFinancialCentsCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
const FinancialCentsCard = (param)=>{
    let { integration } = param;
    const { t: financialCentsTexts } = useLocaleKeys('integrations.availableApps.financialCents');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { FinancialCentsCardTID } = useMemo(()=>GetFinancialCentsCardTID(), []);
    const { api } = useStoreActions();
    const { browser: { changeLocation } } = useIoContext();
    const navigate = useNavigate();
    const isLinked = integrationModel.isLinked(integration);
    const buttonProps = isLinked ? {
        bi: {
            name: 'manage_financial_cents_connection'
        },
        testId: FinancialCentsCardTID.ManageConnection(),
        children: sharedTexts.manageConnection(),
        onClick: ()=>navigate(routes.financialCentsSetup)
    } : {
        bi: {
            name: 'connect_financial_cents'
        },
        testId: FinancialCentsCardTID.Connect(),
        children: sharedTexts.connectButton(),
        onClick: async ()=>{
            const redirectUrl = "".concat(window.location.origin).concat(routes.financialCentsSetup);
            const linkUrl = await api.financialCents.connect(redirectUrl);
            const connectUrl = new URL(linkUrl);
            connectUrl.searchParams.append('host', window.location.host);
            changeLocation(connectUrl.toString());
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: FinancialCentsCardTID.Root(),
        title: financialCentsTexts.title(),
        subTitle: financialCentsTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, _object_spread({}, buttonProps)),
        icon: /*#__PURE__*/ _jsx(FinancialCentsLogo, {
            width: 40,
            height: 40
        }),
        disclaimer: financialCentsTexts.disclaimer()
    });
};
export default FinancialCentsCard;
